import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: 'input[numbersOnly]',
    standalone: false
})
export class NumberOnlyDirective {

  constructor(private _el: ElementRef) {
  }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initialValue = this._el.nativeElement.value;
    // Replace multiple decimal points with a single decimal point
    const newValue = initialValue.replace(/(\.[0-9]*)(\.)/g, '$1');

    // Allow digits and the modified decimal point
    this._el.nativeElement.value = newValue.replace(/[^0-9.]/g, '');
    if (initialValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}
